import { createAction } from '@ngrx/store';

export const openaiActions = {
	// Openai actions
	loadFromOpenai: createAction('[Openai] Load'),
	loadFromOpenaiCompleted: createAction('[Openai] Load Completed'),
};
